export const buttonLabels = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view',
  GO_BACK: 'go Back',
  SAVE: 'save',
  SUBMIT: 'submit',
  DELETE: 'Delete',
  CANCEL: 'Cancel',
  NEXT: 'Next',
}

export const contentMessages = {
  MODEL_HEADING: 'Deleting',
  PROMOTION_CREATE: 'Do you want to create coupon?',
  PROMOTION_UPDATE: 'Do you want to update coupon?',
  MODEL_CONTENT: 'Are you sure do you want to delete ?',
  NO_DATA: '--',
  BOOLEAN: (value: boolean | number | null | undefined) => {
    if (typeof value === 'number') return value === 1 ? 'Yes' : 'No'
    if (typeof value === 'undefined') return '--'
    return value ? 'Yes' : 'No'
  },
}

export const localStorageFields = {
  jwtToken: 'jwtToken',
}

export const pagination = {
  page: 1,
  rowsPerPage: 10,
  pageSizeOptions: [10, 20],
}

export const paginationMode = 'server'

export const inputErrorMessages = {
  REQUIRED: 'This field is required',
  MIN: 'Should be at least',
  MIN_LENGTH: 'Minimum characters required ',
  MAX_LENGTH: 'Maximum characters allowed ',
  MIN_NUMBER: 'Should be minimum ',
  MAX_NUMBER: 'Should be maximum ',
  MOBILE_NUMBER: 'Should be valid mobile number ',
  USER_ID: 'Should be valid user id ',
}

export const inputTypes = {
  TEXT: 'text',
  NUMBER: 'number',
  DROP_DOWN: 'dropdown',
}

export const dateFormat = {
  dateTimeWithTimezone: 'YYYY-MM-DD THH:mm:ss.SSSZ',
  dateFormatFoeCouponRedeem: 'YYYY-MM-DDTHH:mm:ss',
  date: 'DD-MM-YYYY',
  inData: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
  dobDate: 'YYYY-MM-DD hh:mm:ss.sss',
  dateFormatByMonth: 'DD-MMM-YYYY',
  dateTime: 'DD MMM, YYYY  hh:mm:ss A',
  reportsFormat: 'YYYY-MM-DD',
  dateFormatWithFullDate: 'DD MMM, YYYY hh:mm:ss A',
}

export const regexPatterns = {
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{12,}$/,
  number: /^[1-9]\d*$/,
  numberWithZero: /^[0-9]\d*$/,
  upperCase: /[^A-Za-z]/g,
  fourDigits: /^\d{4}$/,
  mobile: /^[0-9]/,
  priceFormat: /^\d{1,4}(\.\d{1,2})?$/,
  phoneNumberFormat: /^[0-9]\d*$/,
  ticketId: /^([A-Za-z]{2,5})-(\d{2,10})$/,
  emailExcludingGuestzee5Domain:
    /^[A-Za-z0-9._%+-]+@(?!guestzee5.com)[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/i,
  templateId: /^TEMP00(1|2|3)(01|02)\d{3}$/,
}

export const minimumCharsForSearch = 3
